import axios from '@axios'
import useJwt from '@/auth/jwt/useJwt'
import config from './config'

const { jwt } = useJwt(axios, config)
export default jwt
